import { defineMessages } from 'react-intl';

export default defineMessages({
  CONTENT: { defaultMessage: 'Découvrez-les sur votre page de progression' },
} as const);
